<template>
  <nav
    class="sb-pagination__pages"
    role="navigation"
    :aria-label="ariaLabel"
  >
    <ul class="sb-pagination__pages-list">
      <li
        v-for="item in displayItems"
        :key="item.key"
        class="sb-pagination__pages-item"
      >
        <template v-if="item.type === 'page'">
          <a
            class="sb-pagination__pages-link"
            href="#"
            :aria-current="currentPage === item.page ? 'page' : undefined"
            @click.prevent="onChangePageButton(item.page)"
          >
            {{ item.page }}
          </a>
        </template>
        <template v-else>
          <SbPaginationOverflow
            :pages="item.pages"
            :aria-label="item.ariaLabel"
            @select="onChangePageButton"
          />
        </template>
      </li>
    </ul>
  </nav>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import SbPaginationOverflow from './SbPaginationOverflow.vue'
import i18n, { type Locale } from '../../../i18n'
import { getPaginationDisplayItems } from './utils'

export type SbPaginationPagesProps = {
  currentPage: number
  pages: number
  locale: Locale
  parentWidth?: number
}

const props = withDefaults(
  defineProps<SbPaginationPagesProps>(),
  {
    parentWidth: 0,
  },
)

const emit = defineEmits<{
  (e: 'change-page', page: number): void
}>()

const ariaLabel = computed(() => i18n(props.locale, 'paginationNavigation'))

const containerWidth = computed(() => props.parentWidth)
const PAGE_BUTTON_MIN_WIDTH = 54
const maxInlineByWidth = computed(() => {
  const max = Math.floor(containerWidth.value / PAGE_BUTTON_MIN_WIDTH)
  return Math.max(5, Math.min(max, 10))
})

const displayItems = computed(() =>
  getPaginationDisplayItems({
    total: props.pages,
    current: props.currentPage,
    maxInline: maxInlineByWidth.value,
    i18n,
    locale: props.locale,
  }),
)

function onChangePageButton(page: number) {
  emit('change-page', page)
}
</script>
